import React, {useEffect, useState} from 'react'
import {withRouter, useHistory, useLocation, useParams, Link} from "react-router-dom"
import axios from 'axios';
import cookie from 'react-cookies';
import {API_URL} from '../../../constants';
import Moment from 'moment';
import moment from 'moment';
import { Pagination } from '../../Elements/Pagination/tablePagination';

function VerNotificacion(props) {

    const [loading, setloading] = useState(true);
    const [data, setdata]       = useState({});
    const [detalle, setdetalle]       = useState({});
    const [pagina, setpagina] = useState(1);

    const params = useParams();

    const getData = () => {
        const {id} = params;
        const url = `${API_URL}NotificacionUX/Seleccionar/${id}`;
        console.log("Parametros",params)
        axios.get(url)
        .then(response => response.data)
        .then((data) => {
            console.log('Notificacion', data);
            if(data.result){
                setdata(data.result);
                setloading(false);
            }
        })
        .catch(error => {
            console.log('Error de comunicación');
        });
    }

    const getListaDetalle = (page = "1") => {
        //console.log("page", page);

        const {id} = params;
        const url = `${API_URL}NotificacionUX/ListarNotificacionDetalle/${id}/${page}`;
        axios.get(url)
        .then(response => response.data)
        .then((data) => {
            console.log('Detalles', data.result);

            setdetalle(data.result);
            setpagina(page)
        })
        .catch(error => {
            console.log('Error de comunicación');
        });
    }

    useEffect(() => {
        if(loading){
            getData();
            getListaDetalle();
        }
    }, []);

    const switchEstado = (param) => {
        switch(param) {
            case 'E':
                return 'Enviado';
            case 'P':
                return 'Pendiente';
            default:
                return 'Error';
        }
    }
    
    return (
        <div>
            <div className="divContenedorBreadcrumbs">
                <div className="divCenterBreadcrumbs">
                    <img src="/static/images/icoBreadcrumb.png" alt="icon home" />
                    <a href="/">
                        / Panel de configuración general
                    </a>
                    <Link to={`/notificaciones`}>
                        <span> / Notificaciones</span>
                    </Link>
                    <span> / Ver notificación</span>
                </div>
            </div>
            <div className="divTitulo_Panel">
                Ver notificación
            </div>
            <div className="divSector_Panel">
                {!loading &&
                    <div className='row justify-content-center'>
                        <div className="col-lg-10">
                            {/* 
                            <h5 className='h6 mb-2'>
                                Titulo: 
                            </h5>
                            <h6 className='h4 font-weight-bold'>
                                {data.titulo}
                            </h6>
                            <hr />
                            */}

                            <div className='mb-3'>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <h6>
                                            <span className='font-weight-normal mr-2'>
                                                ID de la notificación:
                                            </span>
                                        </h6>
                                    </div>
                                    <div className="col-lg-8 text-primary">
                                        {data.noti_Id}
                                    </div>
                                </div>
                            </div>

                            {data.noti_TipoObjeto &&
                            <div className='mb-3'>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <h6>
                                            <span className='font-weight-normal mr-2'>Tipo objeto:</span>
                                        </h6>
                                    </div>
                                    <div className="col-lg-8 text-primary">
                                        {data.noti_TipoObjeto}
                                    </div>
                                </div>
                            </div>
                            }

                            {data.noti_ObjetoId &&
                                <div className='mb-3'>
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <h6>
                                                <span className='font-weight-normal mr-2'>ID del objeto:</span>
                                            </h6>
                                        </div>
                                        <div className="col-lg-8 text-primary">
                                            {data.noti_ObjetoId}
                                        </div>
                                    </div>
                                </div>
                            }

                            {data.noti_Tipo == "C" &&
                                <div className='mb-3'>
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <h6>
                                                <span className='font-weight-normal mr-2'>Titulo:</span>
                                            </h6>
                                        </div>
                                        <div className="col-lg-8 text-primary">
                                            {data.titulo}
                                        </div>
                                    </div>
                                </div>
                            }

                            {data.noti_Tipo == "C" &&
                                <div className='mb-3'>
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <h6>
                                                <span className='font-weight-normal mr-2'>Tipo del recurso:</span>
                                            </h6>
                                        </div>
                                        <div className="col-lg-8 text-primary">
                                            {data.tipo_Recurso}
                                        </div>
                                    </div>
                                </div>
                            }

                            <div className='mb-3'>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <h6>
                                            <span className='font-weight-normal mr-2'>
                                                Tipo de notificación:
                                            </span>
                                        </h6>
                                    </div>
                                    <div className="col-lg-8 text-primary">
                                        {data.noti_TipoDescripcion}
                                    </div>
                                </div>
                            </div>
                            <div className='mb-3'>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <h6>
                                            <span className='font-weight-normal mr-2'>
                                                Tipo de notificación push:
                                            </span>
                                        </h6>
                                    </div>
                                    <div className="col-lg-8 text-primary">
                                        {data.noti_TipoNotificacionPush}
                                    </div>
                                </div>
                            </div>

                            {data.sectores &&
                                <div className='mb-3'>
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <h6>
                                                <span className='font-weight-normal mr-2'>
                                                    Sectores:
                                                </span>
                                            </h6>
                                        </div>
                                        <div className="col-lg-8 text-primary">
                                            {data.sectores}
                                        </div>
                                    </div>
                                </div>
                            }

                            {data.lineasProducto &&
                                <div className='mb-3'>
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <h6>
                                                <span className='font-weight-normal mr-2'>
                                                    Líneas de Producto:
                                                </span>
                                            </h6>
                                        </div>
                                        <div className="col-lg-8 text-primary">
                                            {data.lineasProducto}
                                        </div>
                                    </div>
                                </div>
                            }
                            
                            <div className='mb-3'>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <h6>
                                            <span className='font-weight-normal mr-2'>
                                                Estado:
                                            </span>
                                        </h6>
                                    </div>
                                    <div className="col-lg-8 text-primary">
                                        {data.noti_EstadoDescripcion}
                                    </div>
                                </div>
                            </div>
                            <div className='mb-3'>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <h6>
                                            <span className='font-weight-normal mr-2'>
                                                Fecha de Programación:
                                            </span>
                                        </h6>
                                    </div>
                                    <div className="col-lg-8 text-primary">
                                        {data.noti_FechaProgramacion}
                                    </div>
                                </div>
                            </div>
                            <div className='mb-3'>
                                <div className="row">
                                    <div className="col-lg-4">
                                        <h6>
                                            <span className='font-weight-normal mr-2'>
                                                Fecha de Aprobación:
                                            </span>
                                        </h6>
                                    </div>
                                    <div className="col-lg-8 text-primary">
                                        {data.noti_FechaAprobacion}
                                    </div>
                                </div>
                            </div>

                            {data.noti_Tipo == "P" &&
                                <div className='mb-3'>
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <h6>
                                                <span className='font-weight-normal mr-2'>
                                                    Firebase Título:
                                                </span>
                                            </h6>
                                        </div>
                                        <div className="col-lg-8 text-primary">
                                            {data.noti_FirebaseTitulo}
                                        </div>
                                    </div>
                                </div>
                            }

                            {data.noti_Tipo == "P" &&
                                <div className='mb-3'>
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <h6>
                                                <span className='font-weight-normal mr-2'>
                                                    Firebase Cuerpo:
                                                </span>
                                            </h6>
                                        </div>
                                        <div className="col-lg-8 text-primary">
                                            {data.noti_FirebaseCuerpo}
                                        </div>
                                    </div>
                                </div>
                            }
                            
                            {data.noti_Tipo == "P" &&
                                <div className='mb-3'>
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <h6>
                                                <span className='font-weight-normal mr-2'>
                                                    Firebase Dato Adicional:
                                                </span>
                                            </h6>
                                        </div>
                                        <div className="col-lg-8 text-primary">
                                           { data.noti_FirebaseDatoAdicional }
                                        </div>
                                    </div>
                                </div>
                            }
                                           
                            {data.noti_Tipo == "P" &&
                                <div className='mb-3'>
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <h6>
                                                <span className='font-weight-normal mr-2'>
                                                    Firebase Subtitulo (iOS):
                                                </span>
                                            </h6>
                                        </div>
                                        <div className="col-lg-8 text-primary">
                                           { data.noti_FirebaseSubtitulo }
                                        </div>
                                    </div>
                                </div>
                            }
                             
                            {data.noti_Tipo == "P" &&
                                <div className='mb-3'>
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <h6>
                                                <span className='font-weight-normal mr-2'>
                                                    Firebase Prioridad:
                                                </span>
                                            </h6>
                                        </div>
                                        <div className="col-lg-8 text-primary">
                                           { data.noti_FirebasePrioridad == 'N' ? 'Normal' : (
                                            data.noti_FirebasePrioridad == 'H' ? 'High': (
                                            data.noti_FirebasePrioridad == 'D' ? 'Default ("Normal": Android, "High": iOS)' : ""
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            }

                            {data.noti_ErrorDescripcion &&
                                <div className='mb-3'>
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <h6>
                                                <span className='font-weight-normal mr-2'>
                                                    Descripción del Error:
                                                </span>
                                            </h6>
                                        </div>
                                        <div className="col-lg-8 text-primary">
                                           { data.noti_ErrorDescripcion }
                                        </div>
                                    </div>
                                </div>
                            }

                            {/* {data.noti_Tipo == "P" &&
                                <div className='mb-3'>
                                    <div className="row">
                                        <div className="col-lg-4">
                                            <h6>
                                                <span className='font-weight-normal mr-2'>
                                                    Firebase Ícono:
                                                </span>
                                            </h6>
                                        </div>
                                        <div className="col-lg-8 text-primary">
                                            <img src={data.noti_FirebaseIcono} alt="" className='img-fluid' />
                                        </div>
                                    </div>
                                </div>
                            } */}


                        </div>
                    </div>
                    
                }
                <div className="divTablaPage_Panel">
                        <table border={1} cellSpacing={0}>
                        <tbody>
                            {detalle.length > 0 ?
                             detalle[0].ndet_Tipo == 'C'?
                                <tr>
                                    <th>N°</th>
                                    <th>Correo del Usuario</th>
                                    <th>Estado de Notificacion</th>
                                    <th>RUC</th>
                                </tr>
                                : 
                                <tr>
                                    <th>N°</th>
                                    <th>ID del Usuario</th>
                                    <th>Correo del Usuario</th>
                                    <th>Estado de Notificacion</th>
                                    <th>Push Id</th>
                                    <th>Push Error</th>
                                </tr>
                                :
                                <tr>
                                    <th>Aviso</th>
                                </tr>
                            }   
                            
                                {
                                    detalle.length > 0 ? 

                                    detalle[0].ndet_Tipo == 'C' ?

                                        detalle.map((item, index) => (
                                            <tr key={`pais-codigo-${index}`}>
                                                <td>{(index + 1) + ((pagina - 1) * 10)}</td>
                                                <td>{item.ndet_UsuarioCorreo}</td>
                                                <td>{switchEstado(item.ndet_Estado)}</td>
                                                <td>{item.ndet_RUC}</td>
                                            </tr>
                                        ))
                                    :
                                        detalle.map((item, index) => (
                                            <tr key={`pais-codigo-${index}`}>
                                                <td>{(index + 1) + ((pagina - 1) * 10)}</td>
                                                <td>{item.usua_Id}</td>
                                                <td>{item.ndet_UsuarioCorreo}</td>
                                                <td>{switchEstado(item.ndet_Estado)}</td>
                                                <td>{item.ndet_NotificacionPushId}</td>
                                                <td>{item.ndet_NotificacionPushError}</td>
                                            </tr>
                                        ))
                                    :

                                    (
                                        <tr>
                                            <td colSpan="5" className="tdSinResultados">
                                                No se encontraron destinatarios.
                                            </td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </table>
                        
                    <Pagination
                                data={detalle}
                                pagina={pagina}
                                changePage={(page) => getListaDetalle(page)}
                            />
                    <div className="clear" />
                    </div>
            </div>
        </div>
    )
}

export default withRouter(VerNotificacion);